import type {
  AgentAccessScope,
  AgentDirection,
  AgentInstallStatus,
  AgentResultStatus,
} from './types';

/** Human labels for each business direction (AgentDirection). */
export const DIRECTION_LABELS: Record<AgentDirection, string> = {
  marketing: 'Marketing',
  strategy: 'Strategy',
  sales: 'Sales',
  outbound_bd: 'Outbound BD',
  talent: 'Talent',
  delivery: 'Delivery',
  engineering: 'Engineering',
  internal_ops: 'Internal Ops',
};

/** Stable display order for direction groups on the AI Team roster. */
export const DIRECTION_ORDER: AgentDirection[] = [
  'strategy',
  'marketing',
  'sales',
  'outbound_bd',
  'talent',
  'delivery',
  'engineering',
  'internal_ops',
];

export const INSTALL_STATUS_LABELS: Record<AgentInstallStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  paused: 'Paused',
};

export const ACCESS_SCOPE_LABELS: Record<AgentAccessScope, string> = {
  org_wide: 'Whole organization',
  roles: 'Specific roles',
  departments: 'Specific departments',
  members: 'Specific members',
};

export const RESULT_STATUS_LABELS: Record<AgentResultStatus, string> = {
  draft: 'Draft',
  final: 'Final',
  posted: 'Posted',
};

export const directionLabel = (d: AgentDirection | ''): string =>
  d ? DIRECTION_LABELS[d] : 'Unassigned';
